/**
 * Adee about page — sticky section nav.
 *
 * Highlights whichever section is currently under the header and gives the
 * anchor links a smooth scroll that clears the theme's sticky header. The nav
 * and the sections it points at are separate sections in the theme editor, so
 * links are resolved against the document and any that point at a removed
 * section are ignored.
 */
(function () {
  'use strict';

  var nav, targets = [];

  function headerOffset() {
    // The sticky in-page nav is the only thing pinned to the top of the viewport on
    // this page (the theme header is static and scrolls away), so a section counts as
    // "current" once it passes under the nav.
    var stuck = document.querySelector('.adee-about-sticky-nav');
    return (stuck ? stuck.getBoundingClientRect().height : 0) + 24;
  }

  function collect() {
    nav = document.querySelector('[data-adee-section-nav]');
    targets = [];
    if (!nav) return;
    Array.prototype.forEach.call(nav.querySelectorAll('a[href^="#"]'), function (link) {
      var el = document.getElementById(link.getAttribute('href').slice(1));
      if (el) targets.push({ el: el, link: link });
    });
  }

  function onScroll() {
    if (!targets.length) return;
    var offset = headerOffset(), current = targets[0];
    targets.forEach(function (t) {
      if (t.el.getBoundingClientRect().top <= offset) current = t;
    });
    targets.forEach(function (t) { t.link.classList.toggle('active', t === current); });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-adee-section-nav] a[href^="#"]');
    if (!link) return;
    var el = document.getElementById(link.getAttribute('href').slice(1));
    if (!el) return;
    e.preventDefault();
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset() + 60;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });

  function init() { collect(); onScroll(); }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
